import { render } from "./InspectionResultInterrupted.vue?vue&type=template&id=24ac8498"
import script from "./InspectionResultInterrupted.vue?vue&type=script&lang=js"
export * from "./InspectionResultInterrupted.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__